<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span *ngIf="data.addTask" fxFlex>Add Task</span>
	<span *ngIf="data.editTask" fxFlex>Update Task Details</span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color cursor-pointer"
			>close</mat-icon
		>
	</span>
</h2>
<mat-divider></mat-divider>

<form (keydown.enter)="$event.preventDefault()" [formGroup]="taskDetails">
	<mat-dialog-content class="default-dialog-content">
		<app-default-progress-bar *ngIf="!isFormInitialized"></app-default-progress-bar>

		<div *ngIf="isFormInitialized" class="p-1">
			<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
				<div fxFlex fxLayoutAlign="start center">
					<mat-form-field floatLabel="always" fxFlex="100">
						<input
							formControlName="title"
							matInput
							placeholder="What needs to be done"
							required
							type="text"
						/>
					</mat-form-field>
				</div>
			</div>

			<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
				<div fxFlex>
					<mat-form-field fxFlex="100">
						<input
							(click)="picker2.open()"
							[formControl]="dueDate"
							[matDatepicker]="picker2"
							[min]="minimumDueDate"
							matInput
							placeholder="Due Date"
						/>
						<mat-datepicker-toggle [for]="picker2" matSuffix tabIndex="-1"></mat-datepicker-toggle>
						<mat-datepicker #picker2></mat-datepicker>
					</mat-form-field>
				</div>
			</div>

			<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
				<div fxFlex fxLayoutAlign="start center">
					<app-carrier-search
						(updatedCarrier)="setCarrierId($event)"
						*ngIf="utilService.isNullOrUndefined(data.carrierDTO) && this.utilService.isNullOrUndefined(data.projectDTO)"
						[isForTasks]="true"
						fxFlex
					>
					</app-carrier-search>
					<span
						*ngIf="!utilService.isNullOrUndefined(data.carrierDTO) && !utilService.isNullOrUndefined(data.carrierDTO.id)"
					>
						<span class="label-text-light">Carrier: </span
						><span class="primary-light-color">{{data.carrierDTO.businessName}}</span>
					</span>
					<app-carrier-selector
						(updatedCarrier)="setCarrierId($event)"
						*ngIf="!this.utilService.isNullOrUndefined(data.projectDTO)"
						[projectId]="data.projectDTO.id"
						[useAutoComplete]="true"
						fxFlex
					></app-carrier-selector>
				</div>
			</div>

			<div class="m-t-1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1rem">
				<div fxFlex fxLayoutAlign="start center">
					<app-project-selector
						(projectSelectedEvent)="setProjectId($event)"
						*ngIf="utilService.isNullOrUndefined(data.projectDTO)"
						[accountId]="accountId"
						[labelAlignment]="'start center'"
						fxFlex
					>
					</app-project-selector>
					<span *ngIf="!utilService.isNullOrUndefined(data.projectDTO)">
						<span class="label-text-light">Project: </span
						><span class="primary-light-color">{{data.projectDTO.name}}</span>
					</span>
				</div>
			</div>

			<div *ngIf="isAdminOrOwner" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
				<div class="m-t-1" fxFlex fxLayoutAlign="start center">
					<app-user-selector
						(userChanged)="setAssigneeId($event)"
						[selectedUsers]="selectedUsers"
						[showAssignMe]="true"
						[singleselect]="true"
						fxFlex
					></app-user-selector>
				</div>
			</div>
		</div>
	</mat-dialog-content>
	<mat-divider></mat-divider>

	<mat-dialog-actions class="default-dialog-action">
		<div fxFlex="100" fxLayoutAlign="end end" fxLayoutGap="1rem">
			<button (click)="closeDialog(null)" color="primary" mat-stroked-button>Cancel</button>
			<button
				(click)="data.addTask ? addTask() : null"
				*ngIf="!isRequestInProgress"
				[disabled]="taskDetails.invalid"
				color="primary"
				mat-raised-button
			>
				{{data.addTask ? 'Add Task' : data.editTask ? 'Update Task' : ''}}
			</button>
			<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
		</div>
	</mat-dialog-actions>
</form>
